/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useContext, useEffect, useMemo, useRef, useState } from 'react'

import { mpfRListsHttp } from '../../../assets/ts/api/mpf-r-lists-http'
import { COLUMN_NAMES, LIST_NAME, PascodeMetadata } from '../../../assets/ts/data/pascode-metadata'
import { getUserProfile } from '../../../assets/ts/data/user-profile'
import { generateCode } from '../../../assets/ts/general/general'
import Alert from '../../../components/alert/alert'
import Buttons from '../../../components/buttons/buttons'
import PageOverlayBusy from '../../../components/page-overlay/page-overlay-busy'
import { UserContext } from '../../../store/user-context-provider'
import { SELECT_OPTION, SELECT_OPTION_STRING } from '../../../utils/constants/global-constants'
import { NO_CHANGE_MESSAGE } from '../../../utils/constants/rhybus-config'
import CustomSelect from '../../../utils/controls/custom-select'
import InputText from '../../../utils/controls/input-text'

const AddEditView = ({
  components,
  fetchPascodeMetadata,
  filtersvalue,
  majcoms,
  pascode,
  pascodeMetadata,
  setShowEdit,
  showAddPopup,
  showEdit,
}: any) => {
  const { me, setUserProfile } = useContext(UserContext)
  const titleRef: any = useRef(null)
  const editRef: any = useRef(null)
  const CurrentServicingUnit = [
    SELECT_OPTION_STRING,
    { label: 'MPF', value: 'MPF' },
    { label: 'CSS', value: 'CSS' },
  ]

  const IsArchivedOptions = [
    { label: 'Yes', value: true },
    { label: 'No', value: false },
  ]

  const [showAlert, setShowAlert] = useState(false)
  const [pascodeValidations, setPascodeValidations] = useState({
    additionalPascodes: false,
    assignedComponentCode: false,
    installation: false,
    organization: false,
    pascode: false,
    servicingBy: false,
    servicingCSSPascode: false,
    servicingMAJCOM: false,
    servicingOrganization: false,
  })

  const [inputValues, setInputValues] = useState({
    additionalPascodes: pascode?.AdditionalPASCODEsSupported
      ? pascode.AdditionalPASCODEsSupported
      : '',
    assignedComponentCode: pascode?.AssignedComponentCode ? pascode.AssignedComponentCode : -1,
    code: pascode?.Code ? pascode.Code : -1,
    installation: pascode?.Installation ? pascode.Installation : '',
    isArchived: pascode?.IsArchived ? pascode.IsArchived : false,
    organization: pascode?.Organization ? pascode.Organization : '',
    pascode: pascode?.PASCODE ? pascode.PASCODE : '',
    servicingBy: pascode?.ServicingBy ? pascode.ServicingBy : '',
    servicingCSSPascode: pascode?.ServicingCSSPASCODE ? pascode.ServicingCSSPASCODE : '',
    servicingMAJCOM: pascode?.ServicingMAJCOM ? pascode.ServicingMAJCOM : '',
    servicingOrganization: pascode?.ServicingOrganization
      ? pascode.ServicingOrganization : '',
  })
  const [assignedComponentOptions, setAssignedComponentOptions] = useState<any[]>([])
  const [majcomOptions, setMajcomOptions] = useState<any[]>([])
  const [servicingOrgOptions, setServicingOrgOptions] = useState<any[]>([])

  const initialAssignedComponentOptions = useMemo(() => {
    const assignedCompOptions: any[] = [
      ...components
        .filter((component) => component.ComponentCode !== null)
        .map((component) => ({
          label: component.Component,
          value: component.ComponentCode,
        })),
    ]
    const formattedAssignedComp = [
      SELECT_OPTION,
      ...Object.values(
        assignedCompOptions.reduce(
          (acc, obj) => ({
            ...acc,
            [obj.value]: obj,
          }),
          {}
        )
      ),
    ]

    setAssignedComponentOptions(formattedAssignedComp)

    if (pascode) {
      const majOptions: any[] = [
        ...majcoms
          .filter((majcom) => majcom.MAJCOM !== null && 
          majcom.ParentComponentCode === pascode.AssignedComponentCode)
          .map((majcom) => ({
            label: majcom.MAJCOM,
            value: majcom.MAJCOM,
          })),
      ]
      setMajcomOptions(majOptions)
    }
    return formattedAssignedComp
  }, [components])

  const intialMajcomOptions = useMemo(() => {
    if (!pascode) {const majOptions: any[] = [
      ...majcoms
        .filter((majcom) => majcom.MAJCOM !== null)
        .map((majcom) => ({
          label: majcom.MAJCOM,
          value: majcom.MAJCOM,
        })),
    ]

    const formattedMajcom = [
      SELECT_OPTION_STRING,
      ...Object.values(
        majOptions.reduce(
          (acc, obj) => ({
            ...acc,
            [obj.value]: obj,
          }),
          {}
        )
      ),
    ]
    setMajcomOptions(formattedMajcom)
    return formattedMajcom
    } else {
      const servOrgOptions = pascodeMetadata
        .filter((pas: any) => pas.ServicingMAJCOM === inputValues.servicingMAJCOM)
        .map((servOrg: any) => ({
          label: servOrg.ServicingOrganization,
          value: servOrg.ServicingOrganization,
        }))
      const options = [
        ...Object.values(
          servOrgOptions.reduce(
            (acc, obj) => ({
              ...acc,
              [obj.value]: obj,
            }),
            {}
          )
        ),
      ]
      if (options.length > 1) options.unshift(SELECT_OPTION_STRING) 
      setServicingOrgOptions(options)
    }
  }, [majcoms])

  const [pageOverlay, setPageOverlay] = useState(false)
  const generateIncrementedPASCODECode = async (): Promise<number> => {
    const list = await mpfRListsHttp().getList(LIST_NAME)
    const items = (await list
      .query()
      .select(COLUMN_NAMES.Code)
      .orderBy([{ ascending: false, orderBy: COLUMN_NAMES.Code }])
      .top(1)
      .get()) as PascodeMetadata[]

    const existingCode: any = items.map((m) => m.Code)
    const maxCode = parseInt(existingCode) + 1
    return maxCode as number
  }
  const submitPascode = async () => {
    const isValid = validatePascode()
    const currentDate = new Date()
    if (isValid) {
      setPageOverlay(true)
      const newCode = await generateIncrementedPASCODECode()

      const addObj = {
        AdditionalPASCODEsSupported: inputValues?.additionalPascodes,
        AssignedComponentCode: generateCode(inputValues?.assignedComponentCode),
        Code: inputValues.code === -1 ? newCode : generateCode(inputValues.code),
        Installation: inputValues?.installation,
        IsArchived: inputValues?.isArchived,
        ItemCreated: currentDate,
        ItemCreatedBy: me.rid,
        ItemModified: currentDate,
        ItemModifiedBy: me.rid,
        Organization: inputValues?.organization,
        PASCODE: inputValues?.pascode,
        ServicingBy: inputValues?.servicingBy,
        ServicingCSSPASCODE: inputValues?.servicingCSSPascode,
        ServicingMAJCOM: inputValues?.servicingMAJCOM,
        ServicingOrganization: inputValues?.servicingOrganization,
        eKey: pascode?.eKey ? pascode.eKey : '',
        eTag: pascode?.eTag ? pascode.eTag : '',
      }
      try {
        const list = await mpfRListsHttp().getList(LIST_NAME)
        await list.addOrUpdateItem(addObj)
        const userProfile = await getUserProfile({ userRID: me.rid })
        setUserProfile(userProfile)

        await fetchPascodeMetadata()
      } catch (err) {
        console.error(err)
      }
      setShowEdit(false)
      filtersvalue(false)
      setPageOverlay(false)
    }
  }

  const validatePascode = () => {
    let isValid = true
    const regex = /^[a-zA-Z0-9]*$/
    const validations = {
      additionalPascodes: false,
      assignedComponentCode: false,
      installation: false,
      organization: false,
      pascode: false,
      servicingBy: false,
      servicingCSSPascode: false,
      servicingMAJCOM: false,
      servicingOrganization: false,
    }

    if (inputValues.assignedComponentCode === -1) {
      isValid = false
      validations.assignedComponentCode = true
    }
    if (inputValues.installation.trim() === '') {
      isValid = false
      validations.installation = true
    }
    if (inputValues.organization.trim() === '') {
      isValid = false
      validations.organization = true
    }
    if (inputValues.pascode.trim() === '' || inputValues.pascode.length !== 8 || !regex.test(inputValues.pascode.trim())) {
      isValid = false
      validations.pascode = true
    }
    if (inputValues.servicingBy === '') {
      isValid = false
      validations.servicingBy = true
    }
    if (inputValues.servicingMAJCOM === '') {
      isValid = false
      validations.servicingMAJCOM = true
    }
    if (inputValues.servicingOrganization === '') {
      isValid = false
      validations.servicingOrganization = true
    }
    if (inputValues.additionalPascodes.trim() !== '') {
      const additionalPascodes = inputValues.additionalPascodes.split(',')
      const validPascode = additionalPascodes.every((pascode) => 
        regex.test(pascode.trim()) && pascode.trim().length === 8
      )
      if (!validPascode) {
        isValid = false
        validations.additionalPascodes = true
      }
    }
    if (inputValues.servicingCSSPascode.trim() !== '') {
      if (!(regex.test(inputValues.servicingCSSPascode.trim()) && 
          inputValues.servicingCSSPascode.length === 8)) {
        isValid = false
        validations.servicingCSSPascode = true
      }
    }
    setPascodeValidations(validations)

    if (
      pascode?.AssignedComponentCode === inputValues.assignedComponentCode &&
      pascode?.ServicingBy?.trim() === inputValues.servicingBy.trim() &&
      pascode?.ServicingMAJCOM?.trim() === inputValues.servicingMAJCOM.trim() &&
      pascode?.ServicingOrganization?.trim() === inputValues.servicingOrganization.trim() &&
      pascode?.Installation?.trim() === inputValues.installation.trim() &&
      pascode?.Organization?.trim() === inputValues.organization.trim() &&
      pascode?.PASCODE?.trim() === inputValues.pascode.trim() &&
      (pascode?.AdditionalPASCODEsSupported?.trim() == inputValues.additionalPascodes?.trim() ||
        (pascode?.AdditionalPASCODEsSupported === null &&
          inputValues.additionalPascodes.trim() === '')) &&
      (pascode?.ServicingCSSPASCODE?.trim() == inputValues.servicingCSSPascode?.trim() ||
        (pascode?.ServicingCSSPASCODE === null && inputValues.servicingCSSPascode.trim() === '')) &&
      pascode?.IsArchived === inputValues.isArchived
    ) {
      setShowAlert(true)
      isValid = false
    }

    return isValid
  }

  const onClickAlert = async (button: string) => {
    if (button === 'OK') {
      setShowAlert(false)
    } else {
      setShowAlert(false)
    }
  }

  const onChangeInput = (label: string, value: string) => {
    setInputValues({
      ...inputValues,
      [label]: value,
    })
    if (label === 'servicingMAJCOM') {
      const servOrgOptions = pascodeMetadata
        .filter((pascode: any) => pascode.ServicingMAJCOM === value)
        .map((servOrg: any) => ({
          label: servOrg.ServicingOrganization,
          value: servOrg.ServicingOrganization,
        }))
      const options = [
        ...Object.values(
          servOrgOptions.reduce(
            (acc, obj) => ({
              ...acc,
              [obj.value]: obj,
            }),
            {}
          )
        ),
      ]
      if (options.length > 1 || options.length === 0) options.unshift(SELECT_OPTION_STRING)
      if (options.length === 1) {
        setInputValues((prev) => ({
          ...prev,
          servicingOrganization: options[0].value,
        }))
      } else {
        setInputValues((prev) => ({
          ...prev,
          servicingOrganization: '',
        }))
      }
      setServicingOrgOptions(options)
    }
  }

  const onAssignComponentChange = (e: { label: string; value: number }) => {
    const optionsArr: any[] = [
      ...majcoms
        .filter((majcom: any) => e.value === -1 || majcom.ParentComponentCode === e.value)
        .map((majcom: any) => ({
          label: majcom.MAJCOM,
          value: majcom.MAJCOM,
        })),
    ]

    const options = [
      ...Object.values(
        optionsArr.reduce(
          (acc, obj) => ({
            ...acc,
            [obj.value]: obj,
          }),
          {}
        )
      ),
    ]

    const filteredOpt = options.filter((opt) => opt.label !== null)

    if (filteredOpt.length > 1 || e.value === -1) filteredOpt.unshift(SELECT_OPTION_STRING)
    setMajcomOptions(filteredOpt)

    setInputValues((prev) => ({
      ...prev,
      assignedComponentCode: e.value,
      servicingMAJCOM: options.length === 1 ? options[0].value : '',
      servicingOrganization: '',
    }))

    if (filteredOpt.length === 1) {
      const servOrgOptions = pascodeMetadata
      .filter((pascode: any) => pascode.ServicingMAJCOM === filteredOpt[0].value)
      .map((servOrg: any) =>( {
        label: servOrg.ServicingOrganization,
        value: servOrg.ServicingOrganization,
      }))
      const options = [
        ...Object.values(
          servOrgOptions.reduce(
            (acc, obj) => ({
              ...acc,
              [obj.value]: obj,
            }),
            {}
          )
        ),
      ]
      if (options.length > 1) options.unshift(SELECT_OPTION_STRING)
      if (options.length === 1) {
        setInputValues((prev) => ({
          ...prev,
          servicingOrganization: options[0].value,
        }))
      }
      setServicingOrgOptions(options)
    }
  }
  useEffect(() => {
    const element = document.getElementById('CurrentServicingUnit')
    if (element) {
      if (showAddPopup) {
        element?.focus()
        titleRef?.current?.scrollIntoView({ behavour: 'smooth', block: 'nearest' })
      } else {
        element.focus()
        editRef?.current?.scrollIntoView({ behavour: 'smooth', block: 'end' })
      }
    }
  }, [titleRef, showAddPopup, showEdit])
  return (
    <div
      className={
        showAddPopup
          ? 'mx-2 border-radius whitebg border-primary mt-2'
          : 'settingseditpopup w-100 position-relative mt-2'
      }
      id='scroll'
    >
      {showAlert && (
        <Alert
          alerttextclass='poppins-semibold font-13 text-center'
          btn1className='btn btn btn-sm font-12 poppins-semibold btn-primary whitetext border-radius text-uppercase'
          btn1iconclassNmae='icon-checked font-12 pe-1'
          btn2classNmae='btn btn btn-border1 darktext btn-sm poppins-semibold font-12 border-radius text-uppercase'
          btn2iconclassNmae='icon-close color-primary font-12 pe-1'
          cancel='Cancel'
          className='alert-info'
          message={NO_CHANGE_MESSAGE}
          onClick={onClickAlert}
          yes='OK'
        />
      )}
      {showAddPopup && (
        <div className='p-3 border-bottom1'>
          <h4
            aria-label='ADD PASCODE'
            className='m-0 p-0 d-inline-block font-15 poppins-medium color-primary textcolor4 text-uppercase'
            tabIndex={0}
          >
            ADD PASCODE
          </h4>
        </div>
      )}
      <div className='px-2 py-1'>
        {pageOverlay && <PageOverlayBusy />}
        <div className='row'>
          <div className='col-sm-12 col-lg-3 mb-2'>
            <CustomSelect
              className='form-lg w-100 sourcesanspro font-13 customselect mb-1'
              error={pascodeValidations.servicingBy}
              formClassName='form-vertical text-nowrap poppins-semibold font-11'
              id='CurrentServicingUnit'
              info='Serviced By CSS/MPF '
              infoClassName='tool-tip tooltip-top font-12 sourcesanspro'
              infoIcon='icon-info color-primary'
              inputProps={{
                className: 'mb-1 font-12 poppins-medium title-color',
              }}
              isInfo
              isMandatory
              label='Serviced By CSS/MPF'
              name='Serviced By CSS/MPF'
              onChange={(e) => onChangeInput('servicingBy', e.value)}
              options={CurrentServicingUnit}
              value={inputValues.servicingBy}
            />
          </div>
          <div className='col-sm-12 col-lg-3 mb-2'>
            <CustomSelect
              className='form-lg w-100 sourcesanspro font-13 customselect mb-1'
              error={pascodeValidations.assignedComponentCode}
              formClassName='form-vertical text-nowrap poppins-semibold font-11'
              id='AssignedComponent'
              info='Assigned Component'
              infoClassName='tool-tip tooltip-top font-12 sourcesanspro'
              infoIcon='icon-info color-primary'
              inputProps={{
                className: 'mb-1 font-12 poppins-medium title-color',
              }}
              isInfo
              isMandatory
              label='Assigned Component'
              name='Assigned Component'
              onChange={onAssignComponentChange}
              options={assignedComponentOptions}
              value={inputValues.assignedComponentCode}
            />
          </div>
          <div className='col-sm-12 col-lg-3 mb-2'>
            <CustomSelect
              className='form-lg w-100 sourcesanspro font-13 customselect mb-1'
              error={pascodeValidations.servicingMAJCOM}
              formClassName='form-vertical text-nowrap poppins-semibold font-11'
              id='ServicingMAJCOM'
              info='Servicing MAJCOM'
              infoClassName='tool-tip tooltip-top font-12 sourcesanspro'
              infoIcon='icon-info color-primary'
              inputProps={{
                className: 'mb-1 font-12 poppins-medium title-color',
              }}
              isInfo
              isMandatory
              label='Servicing MAJCOM'
              name='Servicing MAJCOM'
              onChange={(e) => onChangeInput('servicingMAJCOM', e.value)}
              options={majcomOptions}
              value={inputValues.servicingMAJCOM}
            />
          </div>
          <div className='col-sm-12 col-lg-3 mb-2'>
            <CustomSelect
              className='form-lg w-100 sourcesanspro font-13 customselect mb-1'
              error={pascodeValidations.servicingOrganization}
              formClassName='form-vertical text-nowrap poppins-semibold font-11'
              id='ServicingOrganization'
              info='Servicing Organization'
              infoClassName='tool-tip tooltip-top font-12 sourcesanspro'
              infoIcon='icon-info color-primary'
              inputProps={{
                className: 'mb-1 font-12 poppins-medium title-color',
              }}
              isInfo
              isMandatory
              label='Servicing Organization'
              name='Servicing Organization'
              onChange={(e) => onChangeInput('servicingOrganization', e.value)}
              options={servicingOrgOptions}
              value={inputValues.servicingOrganization}
            />
          </div>
          <div className='col-sm-12 col-lg-3 mb-2'>
            <InputText
              changeHandler={(e) => onChangeInput('installation', e.target.value)}
              errorMessage={pascodeValidations.installation}
              formClassName='d-flex flex-column'
              info='Assigned Location '
              infoClassName='tool-tip tooltip-top font-12 sourcesanspro'
              infoIcon='icon-info color-primary'
              inputProps={{
                className: 'poppins-medium font-12 title-color2 mb-1',
                id: ' AssignedLocation ',
                name: ' Assigned Location',
                placeholder: 'Enter Assigned Location',
                value: inputValues.installation,
              }}
              isInfo
              isMandatory
              label=' Assigned Location'
              msg='Please enter an Assigned Location'
            />
          </div>
          <div className='col-sm-12 col-lg-3 mb-2' ref={editRef}>
            <InputText
              changeHandler={(e) => onChangeInput('organization', e.target.value)}
              errorMessage={pascodeValidations.organization}
              formClassName='d-flex flex-column'
              info='Organization'
              infoClassName='tool-tip tooltip-top font-12 sourcesanspro'
              infoIcon='icon-info color-primary'
              inputProps={{
                className: 'poppins-medium font-12 title-color2 mb-1',
                id: ' Organization ',
                name: ' Organization',
                placeholder: 'Enter Organization',
                value: inputValues.organization,
              }}
              isInfo
              isMandatory
              label='Organization'
              msg='Please enter an Organization'
            />
          </div>

          <div className='col-sm-12 col-lg-3 mb-2'>
            <InputText
              changeHandler={(e) => onChangeInput('pascode', e.target.value)}
              errorMessage={pascodeValidations.pascode}
              formClassName='d-flex flex-column'
              info='PASCODE'
              infoClassName='tool-tip tooltip-top font-12 sourcesanspro'
              infoIcon='icon-info color-primary'
              inputProps={{
                className: 'poppins-medium font-12 title-color2 mb-1',
                id: ' PASCODE ',
                maxLength: 8,
                name: ' PASCODE',
                placeholder: 'Enter PASCODE',
                value: inputValues.pascode,
              }}
              isInfo
              isMandatory
              label='PASCODE'
              msg='Please enter a PASCODE'
            />
          </div>
          {pascode?.IsArchived !== undefined && (
            <div className='col-sm-12 col-lg-3 mb-2'>
              <CustomSelect
                className='form-lg w-100 sourcesanspro font-13 customselect mb-1'
                formClassName='form-vertical text-nowrap poppins-semibold font-11'
                id='Archived'
                info='Archived'
                infoClassName='tool-tip tooltip-top font-12 sourcesanspro'
                infoIcon='icon-info color-primary'
                inputProps={{
                  className: 'mb-1 font-12 poppins-medium title-color',
                }}
                isInfo
                label='Archived'
                name='Archived'
                onChange={(e) => onChangeInput('isArchived', e.value)}
                options={IsArchivedOptions}
                value={inputValues.isArchived}
              />
            </div>
          )}
          <div className='col-sm-12 col-lg-8 mb-2'>
            <InputText
              changeHandler={(e) => onChangeInput('additionalPascodes', e.target.value)}
              errorMessage={pascodeValidations.additionalPascodes}
              formClassName='d-flex flex-column'
              info='Additional PASCODE’s Supported'
              infoClassName='tool-tip tooltip-top font-12 sourcesanspro'
              infoIcon='icon-info color-primary'
              inputProps={{
                className: 'poppins-medium font-12 title-color2 mb-1',
                id: ' AdditionalPASCODEsSupported ',
                name: ' Additional PASCODE’s Supported',
                placeholder: 'Additional PASCODE’s Supported',
                value: inputValues.additionalPascodes,
              }}
              isInfo
              label='Additional PASCODE’s Supported'
              msg='Please enter a PASCODE separated by commas if more than one'
            />
          </div>
          <div className='col-sm-12 col-lg-4 mb-2'>
            <InputText
              changeHandler={(e) => onChangeInput('servicingCSSPascode', e.target.value)}
              errorMessage={pascodeValidations.servicingCSSPascode}
              formClassName='d-flex flex-column'
              info='Servicing CSS PASCODE if different'
              infoClassName='tool-tip tooltip-top font-12 sourcesanspro'
              infoIcon='icon-info color-primary'
              inputProps={{
                className: 'poppins-medium font-12 title-color2 mb-1',
                id: ' ServicingCSS',
                maxLength: 8,
                name: ' Servicing CSS PASCODE if different',
                placeholder: 'Servicing CSS PASCODE if different',
                value: inputValues.servicingCSSPascode,
              }}
              isInfo
              label='Servicing CSS PASCODE if different'
              msg='Please enter a PASCODE'
            />
          </div>
        </div>
        <div className='d-flex py-1 flex-wrap'>
          <div className='ms-auto settingsbtns d-flex' ref={titleRef}>
            {showAddPopup && (
              <>
                <Buttons
                  className='btn-border-radius3 py-1 px-3 btn-bgcolor9  ms-2 whitetext poppins-medium font-12 text-uppercase btn-xs'
                  icon='icon-save font-11 pe-1'
                  label='Save'
                  onClick={() => submitPascode()}
                  type='button'
                />
                <Buttons
                  className='py-1 px-3 btn-border-radius3 btn-border1 ms-2 poppins-medium font-12 text-uppercase btn-xs'
                  icon='icon-close color-primary font-9 pe-1'
                  label='Cancel'
                  onClick={() => {
                    filtersvalue(!showAddPopup)
                  }}
                  type='button'
                />{' '}
              </>
            )}
            {!showAddPopup && (
              <>
                <Buttons
                  className='btn-border-radius3 py-1 px-3 btn-bgcolor9  ms-2 whitetext poppins-medium font-12 text-uppercase btn-xs'
                  icon='icon-update font-11 pe-1'
                  label='Update'
                  onClick={() => submitPascode()}
                  type='button'
                />
                <Buttons
                  className='py-1 px-3 btn-border-radius3 btn-border1 ms-2 poppins-medium font-12 text-uppercase btn-xs'
                  icon='icon-close color-primary font-9 pe-1'
                  label='Cancel'
                  onClick={() => {
                    setShowEdit(false)
                  }}
                  type='button'
                />
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
export default AddEditView
